
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import { toast } from "react-toastify";
import "./formTitle.css";
import "./themePlaceholder.css";


function UKPNMST() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    ramsRef: "",
    contract: "",
    revision: "",
    address: "",
    briefedByName: "",
    position: "",
    dateMain: "",
    siteName: "",
    nameGroup: "",
    dateGroup: "",
    signatureGroup: ""
  });

  // Single signature block
  const [signature, setSignature] = useState({
    name: "",
    date: "",
    signature: "",
    ref: React.createRef()
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignatureChange = (field, value) => {
    setSignature(prev => ({ ...prev, [field]: value }));
  };

  const clearSignature = () => {
    const ref = signature.ref;
    if (ref.current) ref.current.clear();
    setSignature(prev => ({ ...prev, signature: "" }));
  };

  const saveSignature = () => {
    const ref = signature.ref;
    if (ref.current && !ref.current.isEmpty()) {
      setSignature(prev => ({
        ...prev,
        signature: ref.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      
      // Get userId from localStorage user
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user && user.id;
      if (!userId) {
        toast.error("User not found");
        return;
      }
      
      // Update form with signature data and userId
      const finalForm = {
        ...form,
        userId,
        nameGroup: signature.name,
        dateGroup: signature.date,
        signatureGroup: signature.signature
      };
      
      const res = await fetch(baseUrl + "/api/ukpn-mst", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json", 
          "Authorization": `Bearer ${token}` 
        },
        body: JSON.stringify(finalForm)
      });
      
      const data = await res.json();
      if (res.ok && data.success) {
        toast.success("UKPN MST Form submitted successfully!");
        navigate(-1);
      } else {
        toast.error(data.message || "Failed to submit form");
      }
    } catch (error) {
      toast.error("Failed to submit form");
    }
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4 position-relative">
        <button
          onClick={() => window.history.back()}
          className="btn fw-semibold position-absolute"
          style={{
            left: "-63px",
            color: "#8b1634",
            padding: "8px 20px",
            whiteSpace: "nowrap",
            zIndex: 10,
          }}
        >
          <i className="fa fa-arrow-left"></i> Back
        </button>
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            UKPN MST Form
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* RAMS Ref */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">RAMS Ref</label>
                <input
                  type="text"
                  className="form-control"
                  name="ramsRef"
                  value={form.ramsRef}
                  onChange={handleChange}
                  required
                  placeholder="Enter RAMS Ref"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #8b1634",
                    fontSize: "1.08rem"
                  }}
                  onFocus={e => e.target.style.borderColor = "#8b1634"}
                  onBlur={e => e.target.style.borderColor = "#8b1634"}
                />
              </div>
              {/* Contract */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Contract</label>
                <input
                  type="text"
                  className="form-control"
                  name="contract"
                  value={form.contract}
                  onChange={handleChange}
                  required
                  placeholder="Enter Contract"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #8b1634",
                    fontSize: "1.08rem"
                  }}
                  onFocus={e => e.target.style.borderColor = "#8b1634"}
                  onBlur={e => e.target.style.borderColor = "#8b1634"}
                />
              </div>
              {/* Revision */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Revision</label>
                <input
                  type="text"
                  className="form-control"
                  name="revision"
                  value={form.revision}
                  onChange={handleChange}
                  required
                  placeholder="Enter Revision"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #8b1634",
                    fontSize: "1.08rem"
                  }}
                  onFocus={e => e.target.style.borderColor = "#8b1634"}
                  onBlur={e => e.target.style.borderColor = "#8b1634"}
                />
              </div>
              {/* Address */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  required
                  placeholder="Enter Address"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #8b1634",
                    fontSize: "1.08rem"
                  }}
                  onFocus={e => e.target.style.borderColor = "#8b1634"}
                  onBlur={e => e.target.style.borderColor = "#8b1634"}
                />
              </div>

              {/* Section Heading + Briefed by name + Position in one row */}
              <div className="col-12">
                <span className="fw-bold" style={{ color: "#8b1634", fontSize: "1.1rem", display: "block", marginBottom: "8px" }}>
                  Method Statement and Risk Assessment Briefing Form
                </span>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-secondary">Briefed by name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="briefedByName"
                      value={form.briefedByName}
                      onChange={handleChange}
                      required
                      placeholder="Enter Name"
                      style={{
                        background: "#f7fafd",
                        borderRadius: "10px",
                        border: "1.5px solid #8b1634",
                        fontSize: "1.08rem"
                      }}
                      onFocus={e => e.target.style.borderColor = "#8b1634"}
                      onBlur={e => e.target.style.borderColor = "#8b1634"}
                    />
                    <span style={{ color: "#8b1634", fontWeight: 500, fontSize: "1rem", display: "block", marginTop: "6px" }}>
                      Company: Taylor Technology Systems Ltd
                    </span>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-secondary">Position</label>
                    <input
                      type="text"
                      className="form-control"
                      name="position"
                      value={form.position}
                      onChange={handleChange}
                      required
                      placeholder="Enter Position"
                      style={{
                        background: "#f7fafd",
                        borderRadius: "10px",
                        border: "1.5px solid #8b1634",
                        fontSize: "1.08rem"
                      }}
                      onFocus={e => e.target.style.borderColor = "#8b1634"}
                      onBlur={e => e.target.style.borderColor = "#8b1634"}
                    />
                  </div>
                </div>
              </div>
              {/* Date */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="dateMain"
                  value={form.dateMain}
                  onChange={handleChange}
                  required
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #8b1634",
                    fontSize: "1.08rem"
                  }}
                  onFocus={e => e.target.style.borderColor = "#8b1634"}
                  onBlur={e => e.target.style.borderColor = "#8b1634"}
                />
              </div>
              {/* Site Name */}
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary">Site Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="siteName"
                  value={form.siteName}
                  onChange={handleChange}
                  required
                  placeholder="Enter Site Name"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #8b1634",
                    fontSize: "1.08rem"
                  }}
                  onFocus={e => e.target.style.borderColor = "#8b1634"}
                  onBlur={e => e.target.style.borderColor = "#8b1634"}
                />
              </div>

              {/* Signature Section */}
              <div className="col-12 mt-3">
                  <div className="card p-3" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #eaf0fe" }}>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary">Name</label>
                        <input
                          type="text"
                          className="form-control"
                        name="nameGroup"
                        value={signature.name}
                        onChange={e => handleSignatureChange("name", e.target.value)}
                          required
                          placeholder="Enter Name"
                          style={{
                            background: "#f7fafd",
                            borderRadius: "10px",
                            border: "1.5px solid #8b1634",
                            fontSize: "1.08rem"
                          }}
                          onFocus={e => e.target.style.borderColor = "#8b1634"}
                          onBlur={e => e.target.style.borderColor = "#8b1634"}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary">Date</label>
                        <input
                          type="date"
                          className="form-control"
                        name="dateGroup"
                        value={signature.date}
                        onChange={e => handleSignatureChange("date", e.target.value)}
                          required
                          style={{
                            background: "#f7fafd",
                            borderRadius: "10px",
                            border: "1.5px solid #8b1634",
                            fontSize: "1.08rem"
                          }}
                          onFocus={e => e.target.style.borderColor = "#8b1634"}
                          onBlur={e => e.target.style.borderColor = "#8b1634"}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-secondary">Signature</label>
                        <div style={{
                          width: '100%',
                          border: '2px solid #8b1634',
                          borderRadius: '18px',
                          background: '#e9cfd6',
                          padding: '0.5rem',
                          textAlign: 'left',
                          position: 'relative',
                          minHeight: '120px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center'
                        }}>
                          <SignatureCanvas
                          ref={signature.ref}
                            penColor="#8b1634"
                            backgroundColor="#e9cfd6"
                            clearOnResize={false}
                            velocityFilterWeight={0.7}
                            minWidth={1}
                            maxWidth={2.5}
                            dotSize={1.5}
                            throttle={16}
                            canvasProps={{
                              width: window.innerWidth > 600 ? 350 : 300,
                              height: 100,
                              style: {
                                width: '100%',
                                height: '100px',
                                border: 'none',
                                borderRadius: '18px',
                                background: '#e9cfd6',
                                display: 'block',
                                touchAction: 'none'
                              }
                            }}
                          onEnd={saveSignature}
                          />
                          <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '4px'
                          }}>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm rounded-pill px-3"
                              style={{
                                background: 'transparent',
                                color: '#8b1634',
                                borderColor: '#8b1634'
                              }}
                            onClick={clearSignature}>
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>

              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2"
                  style={{
                    backgroundColor: "#8b1634",
                    borderRadius: "30px",
                    boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                  }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UKPNMST;
